module.exports = __webpack_public_path__ + "static/media/plus.7226895b.svg";